import commonStrings from 'resources/commonStrings';
import { reportIdentifiers } from '../GrowthReports/reportDetails';

export const reportDetails = {
  recoveryGoalSetting: {
    urlEndPoint: `recoverygoal-setting`,
    isEnabled: reportIdentifiers.includes('recoveryGoalSetting'),
    disabledMessage: commonStrings.disabledReportMessages.recoveryGoalSettingReport,
  },
};

export const reportEndpoints = Object.values(reportDetails).reduce((acc, report) => {
  if (report.isEnabled) {
    acc.push(report.urlEndPoint);
  }
  return acc;
}, []);

export default reportDetails;
